import Portfolio from './portfolio.tsx';
import { Toaster } from 'react-hot-toast';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <>
      <Toaster />
      <Portfolio />
      <Analytics />
    </>
  );
}

export default App;